<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CeT8Gg/tc-custom/9781609453282.jpg?1736610082639" alt="This image is the cover for the book Neapolitan Novels Boxed Set, Neapolitan Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Neapolitan Novels Boxed Set, Neapolitan Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>In one volume, the <i>New York Times</i>–bestselling epic about hardship and female friendship in postwar Naples that has sold over five million copies</b>.<br/>  <br/> Beginning with <i>My Brilliant Friend</i>, the four Neapolitan Novels by Elena Ferrante follow Elena and Lila, from their rough-edged upbringing in Naples, Italy, not long after WWII, through the many stages of their lives—and along paths that diverge wildly. Sometimes they are separated by jealousy or hostility or physical distance, but the bond between them is unbreakable, for better or for worse.<br/>  <br/> This volume includes all four novels: <i>My Brilliant Friend</i>; <i>The Story of a New Name</i>; <i>Those Who Leave and Those Who Stay</i>; and <i>The Story of the Lost Child</i>.<br/>  <br/> “Imagine if Jane Austen got angry and you’ll have some idea of how explosive these works are.” —<i>The Australian</i><br/>  <br/> “Nothing you read about Elena Ferrante’s work prepares you for the ferocity of it.” —<i>The New York Times</i><br/>  <br/> “An enduring masterpiece.” —<i>The Atlantic</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elena Ferrante, Ann Goldstein
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53dde832